import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import DOMPurify from "dompurify";

const KeywordTriggeredBanner = (props) => {
  const { bannerMarkup, className } = props;

  const componentClass = classnames("sal-keyword-triggered-banner", className);

  return bannerMarkup ? (
    <div
      className={componentClass}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bannerMarkup) }}
    />
  ) : null;
};

KeywordTriggeredBanner.propTypes = {
  bannerMarkup: PropTypes.string,
  className: PropTypes.string,
};

export default KeywordTriggeredBanner;
